// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2zs1_","list":"styles_list__3zHa8"};